import React from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import { PatchUserRequest } from "hooks/useUserDetails";
import {
  SectionTitle,
  EditFormGrid,
  FormField,
  FormLabel,
  CheckboxRow,
  CheckboxLabel,
  CheckboxesSection,
  FormActions,
} from "styles/components/userDetails.styles";

interface Props {
  form: PatchUserRequest;
  isSaving: boolean;
  onChange: (updated: PatchUserRequest) => void;
  onSave: () => void;
}

const UserEditTab: React.FC<Props> = ({ form, isSaving, onChange, onSave }) => {
  const set = (patch: Partial<PatchUserRequest>) =>
    onChange({ ...form, ...patch });

  return (
    <div style={{ marginTop: "1rem" }}>
      <SectionTitle>
        <i className="pi pi-user-edit" />
        Edit User Details
      </SectionTitle>

      <EditFormGrid>
        <FormField>
          <FormLabel htmlFor="edit-firstname">First Name</FormLabel>
          <InputText
            id="edit-firstname"
            value={form.firstname ?? ""}
            onChange={(e) => set({ firstname: e.target.value })}
          />
        </FormField>
        <FormField>
          <FormLabel htmlFor="edit-lastname">Last Name</FormLabel>
          <InputText
            id="edit-lastname"
            value={form.lastname ?? ""}
            onChange={(e) => set({ lastname: e.target.value })}
          />
        </FormField>
        <FormField>
          <FormLabel htmlFor="edit-email">Email</FormLabel>
          <InputText
            id="edit-email"
            value={form.email ?? ""}
            onChange={(e) => set({ email: e.target.value })}
          />
        </FormField>
        <FormField>
          <FormLabel htmlFor="edit-city">City</FormLabel>
          <InputText
            id="edit-city"
            value={form.city ?? ""}
            onChange={(e) => set({ city: e.target.value })}
          />
        </FormField>
        <FormField>
          <FormLabel htmlFor="edit-country">Country</FormLabel>
          <InputText
            id="edit-country"
            value={form.country ?? ""}
            onChange={(e) => set({ country: e.target.value })}
          />
        </FormField>
        <FormField>
          <FormLabel htmlFor="edit-language">Language</FormLabel>
          <InputText
            id="edit-language"
            value={form.language ?? ""}
            onChange={(e) => set({ language: e.target.value })}
          />
        </FormField>
      </EditFormGrid>

      <CheckboxesSection>
        <CheckboxRow>
          <Checkbox
            inputId="edit-notifications"
            checked={form.allowsnotifications ?? false}
            onChange={(e) => set({ allowsnotifications: e.checked ?? false })}
          />
          <CheckboxLabel htmlFor="edit-notifications">
            Allows Notifications
          </CheckboxLabel>
        </CheckboxRow>
        <CheckboxRow>
          <Checkbox
            inputId="edit-marketing"
            checked={form.marketingmaterialok ?? false}
            onChange={(e) => set({ marketingmaterialok: e.checked ?? false })}
          />
          <CheckboxLabel htmlFor="edit-marketing">
            Marketing Emails
          </CheckboxLabel>
        </CheckboxRow>
        <CheckboxRow>
          <Checkbox
            inputId="edit-updates"
            checked={form.updatesok ?? false}
            onChange={(e) => set({ updatesok: e.checked ?? false })}
          />
          <CheckboxLabel htmlFor="edit-updates">Product Updates</CheckboxLabel>
        </CheckboxRow>
      </CheckboxesSection>

      <FormActions>
        <Button
          label="Save Changes"
          icon="pi pi-save"
          onClick={onSave}
          loading={isSaving}
        />
      </FormActions>
    </div>
  );
};

export default UserEditTab;
